import type { FontOption, SizeOption, FontId, SizeId } from "./types";
import { createFallbackStickerSizeOption } from "./size-contract";

// ---------------------------------------------------------------------------
// Fonts
// ---------------------------------------------------------------------------

export const FONTS: FontOption[] = [
  {
    id: "fredoka",
    label: "Fredoka",
    fontFamily: "'Fredoka', sans-serif",
    tags: ["popular", "rounded", "sans"],
  },
  {
    id: "nunito",
    label: "Nunito",
    fontFamily: "'Nunito', sans-serif",
    tags: ["popular", "rounded", "sans"],
  },
  {
    id: "baloo",
    label: "Baloo 2",
    fontFamily: "'Baloo 2', sans-serif",
    tags: ["popular", "rounded", "sans"],
  },
  {
    id: "round",
    label: "Rounded Mplus",
    fontFamily: "'M PLUS Rounded 1c', sans-serif",
    tags: ["rounded", "sans"],
  },
  {
    id: "bungee",
    label: "Bungee",
    fontFamily: "'Bungee', sans-serif",
    tags: ["display"],
  },
  {
    id: "lilita",
    label: "Lilita One",
    fontFamily: "'Lilita One', sans-serif",
    tags: ["popular", "display"],
  },
  {
    id: "bowlby",
    label: "Bowlby One",
    fontFamily: "'Bowlby One', sans-serif",
    tags: ["display"],
  },
  {
    id: "sniglet",
    label: "Sniglet",
    fontFamily: "'Sniglet', sans-serif",
    tags: ["rounded", "sans"],
  },
  {
    id: "patrick",
    label: "Patrick Hand",
    fontFamily: "'Patrick Hand', cursive",
    tags: ["handwritten"],
  },
  {
    id: "comic",
    label: "Comic Neue",
    fontFamily: "'Comic Neue', cursive",
    tags: ["handwritten"],
  },
  {
    id: "inter",
    label: "Inter",
    fontFamily: "'Inter', sans-serif",
    tags: ["sans"],
  },
  {
    id: "plex",
    label: "IBM Plex Sans",
    fontFamily: "'IBM Plex Sans', sans-serif",
    tags: ["sans"],
  },
  {
    id: "robotoSlab",
    label: "Roboto Slab",
    fontFamily: "'Roboto Slab', serif",
    tags: ["serif"],
  },
  {
    id: "playfair",
    label: "Playfair Display",
    fontFamily: "'Playfair Display', serif",
    tags: ["serif", "display"],
  },
  {
    id: "cinzel",
    label: "Cinzel",
    fontFamily: "'Cinzel', serif",
    tags: ["serif", "display"],
  },
  {
    id: "greatVibes",
    label: "Great Vibes",
    fontFamily: "'Great Vibes', cursive",
    tags: ["script", "handwritten"],
  },
  {
    id: "dmSerif",
    label: "DM Serif Display",
    fontFamily: "'DM Serif Display', serif",
    tags: ["serif", "display"],
  },
  {
    id: "workSans",
    label: "Work Sans",
    fontFamily: "'Work Sans', sans-serif",
    tags: ["sans"],
  },
];

// ---------------------------------------------------------------------------
// Lookup helpers
// ---------------------------------------------------------------------------

export function getFontById(id: FontId): FontOption | undefined {
  return FONTS.find((f) => f.id === id);
}

export function getSizeById(id: SizeId): SizeOption | undefined {
  return createFallbackStickerSizeOption(id);
}
